import { Link } from 'react-router-dom'
import type { Service } from '../../../shared/types'
import { formatPrice } from '@/utils'

interface ServiceCardProps {
  service: Service
}

export function ServiceCard({ service }: ServiceCardProps) {
  return (
    <Link to={`/booking?service=${service.id}`} className="card-active block">
      <div className="flex gap-4">
        {service.image_url && (
          <div className="w-20 h-20 flex-shrink-0 rounded-xl overflow-hidden bg-primary-100">
            <img
              src={service.image_url}
              alt={service.name}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 mb-1 truncate">{service.name}</h3>
          {service.description && (
            <p className="text-sm text-gray-600 line-clamp-2 mb-2">{service.description}</p>
          )}
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">{service.duration}分钟</span>
            <span className="text-lg font-bold text-primary-600">{formatPrice(service.price)}</span>
          </div>
        </div>
      </div>
    </Link>
  )
}
